import React, { Component } from "react";
import LanguageMenu from "../components/header/LanguageMenu";

export default class LanguageMenuContainer extends Component {
  state = {
    anchorEl: null
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  changeLanguage = lang => {
    localStorage.setItem("userLanguage", lang);
    window.location.reload();
    this.handleClose();
  };

  generateProps = () => ({
    ...this.state,
    ...this.props,
    open: Boolean(this.state.anchorEl),
    handleMenu: this.handleMenu,
    handleClose: this.handleClose,
    changeLanguage: this.changeLanguage
  });

  render() {
    return <LanguageMenu {...this.generateProps()} />;
  }
}
